// extracted by mini-css-extract-plugin
export var chip = "_5x-9";
export var chipLabel = "_5x-a";
export var close = "_5x-7";
export var closeIcon = "_5x-8";
export var error = "_5x-6";
export var infoTooltip = "_5x-2";
export var innerContainer = "_5x-1";
export var input = "_5x-b";
export var medium = "_5x-5";
export var outerContainer = "_5x-0";
export var small = "_5x-4";
export var xSmall = "_5x-3";